import axios from 'axios';
import { makeAutoObservable, runInAction } from 'mobx';

import type { IDashboardService, Wellbore } from '../api/IDashboardService';

export class Wellbores {
  inProgress = false;

  list: Wellbore[] = [];

  selected: Wellbore | null = null;

  constructor(
    private dashboardService: IDashboardService,
    private onWellboreChange?: (wellbore: Wellbore) => void,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async fetchWellbores(wellId: number, abortController?: AbortController) {
    this.inProgress = true;

    try {
      const [data] = await Promise.all([this.dashboardService.getWellbores(wellId, abortController)]);
      runInAction(() => {
        this.list = data;
      });
      return data;
    } catch (e: unknown) {
      if (!axios.isCancel(e)) {
        throw e;
      }
      return [];
    } finally {
      runInAction(() => {
        this.inProgress = false;
      });
    }
  }

  getWellboreById(id: number): Wellbore | null {
    return this.list.find((wellbore) => wellbore.id === id) ?? null;
  }

  setSelected(wellbore: Wellbore) {
    this.selected = wellbore;
    if (this.onWellboreChange) this.onWellboreChange(wellbore);
  }

  getDefaultSelected(selectActive: boolean, selectedWellboreId?: number): Wellbore | null {
    if (selectedWellboreId) {
      const w = this.getWellboreById(selectedWellboreId);
      if (w) {
        return w;
      }
    }
    if (selectActive) {
      const id = this.list.find((wellbore) => wellbore.active);
      if (id) {
        return id;
      }
    } else {
      const mainSlugs = this.list.filter((wellbore) => {
        return wellbore.typeSlug === 'Main';
      });
      const wellbore = mainSlugs.find((mainSlug) => mainSlug.redrilling === false) ?? mainSlugs[0];
      if (wellbore) {
        return wellbore;
      }
    }
    if (this.list.length > 0) {
      return this.list[0];
    }
    return null;
  }

  clear() {
    this.list = [];
    this.selected = null;
  }
}
